interface NavItem {
	/** Display label for the nav item */
	label: string;
	/** Route path */
	path: string;
	/** Also active on any path under this prefix (e.g. an event's own pages). */
	matchPrefix?: boolean;
	/** Shown to a team's exhibitors too; everything else is staff-only (root ADR-036). */
	exhibitor?: boolean;
}

/**
 * Main navigation, in the order `TopNav` draws it. Text links only: the
 * design's nav carries no icons, and at phone width the row scrolls sideways
 * under the brand rather than becoming a bottom bar.
 */
export const navItems: NavItem[] = [
	{ label: "Home", path: "/dashboard", exhibitor: true },
	{ label: "Events", path: "/events", matchPrefix: true },
	{ label: "Billing", path: "/billing" },
];
